import { useCallback } from 'react';
import { useRouter } from 'next/router';
import { addQueryStringParam, removeQueryStringParam } from '@framework/url/helpers/queryString';
import { QUERY_PARAMS_TO_REMOVE } from '@/creditflowresearch/application/Research/constants';

interface IUrlActions {
  removeFilterParamsFromUrl: () => void,
  updateUrlWithParams: (params: Record<string, any>) => void,
}

interface IUseFilterUrlOptions {
  shallow?: boolean,
}

export const useFilterUrl = ({ shallow = false }: IUseFilterUrlOptions = {}): IUrlActions => {
  const { push, replace } = useRouter();

  const removeFilterParamsFromUrl = useCallback(() => {
    const newSearch = removeQueryStringParam(window.location, QUERY_PARAMS_TO_REMOVE);
    push(`${ window.location.pathname }?${ newSearch }`, undefined, { shallow });
  }, [push, shallow]);

  const updateUrlWithParams = useCallback((params: Record<string, any>) => {
    const newSearch = addQueryStringParam(window.location, params);
    replace(`${ window.location.pathname }?${ newSearch }`, undefined, { shallow });
  }, [replace, shallow]);

  return {
    removeFilterParamsFromUrl,
    updateUrlWithParams,
  };
};
